import axios, { AxiosError } from 'axios';
import { getLogger } from '../diagnostics/logger';
import { getSimManagementErrorFromAxiosError } from '.';
import { SimCommandDefinition } from '../models/transfer/input/SimCommandDefinition';

import config from '../config';
const log = getLogger('simManagement.api.commandDefinitionApi');

export function getByCommandType(commandType: string): Promise<SimCommandDefinition[]> {
  const url = `${config.API_BASE_URL}api/simCommandType/${commandType}/definition`;
  return new Promise<SimCommandDefinition[]>((resolve, reject) => {
    axios
      .get(url)
      .then((response: any) => {
        const result = response.data as SimCommandDefinition[];
        resolve(result);
      })
      .catch((error: any) => {
        const simManagementError = getSimManagementErrorFromAxiosError(error as AxiosError);
        log.error('Failed to obtain SIM command types', simManagementError);

        reject(simManagementError);
      });
  });
}
